import type { FC } from "react";

interface MenuStepProps {
  onReportIssue: () => void;
  onCheckOut: () => void;
}

const MenuStep: FC<MenuStepProps> = ({ onReportIssue, onCheckOut }) => (
  <div className="relative z-10 flex flex-1 flex-col items-center px-6">
    <div className="grid w-full max-w-sm flex-1 grid-rows-[1fr_auto_1fr]">
      {/* Top row: content pinned to bottom */}
      <div className="flex flex-col justify-end pb-20">
        {/* Logo */}
        <div className="bc-fade-up text-center">
          <img
            src={new URL("../assets/ths-footer-logo.svg", import.meta.url).href}
            alt="Team Housing Solutions"
            className="mx-auto w-48 sm:w-56"
          />
        </div>

        {/* Divider */}
        <div className="bc-fade-up bc-fade-up-1 mt-10 h-px w-full bg-gradient-to-r from-transparent via-white/10 to-transparent" />

        {/* Heading */}
        <div className="bc-fade-up bc-fade-up-1 mt-10 text-center">
          <h1 className="font-oswald text-3xl font-medium uppercase tracking-wide text-white sm:text-4xl">
            What would you like to do?
          </h1>
        </div>
      </div>

      {/* Center + bottom rows: buttons stacked, anchored just under the heading */}
      <div className="bc-fade-up bc-fade-up-2 flex flex-col gap-3">
        <button
          type="button"
          onClick={onReportIssue}
          className="w-full rounded-xl border border-amber-400/30 bg-amber-400/10 px-8 py-3.5 text-sm font-semibold text-amber-200 transition-all hover:border-amber-400/50 hover:text-amber-100 active:scale-[0.98]"
        >
          Report an issue
        </button>
        <button
          type="button"
          onClick={onCheckOut}
          className="w-full rounded-xl bg-accentGreen px-8 py-3.5 text-sm font-semibold text-primaryDarkBlue shadow-lg shadow-accentGreen/25 transition-all active:scale-[0.98]"
        >
          Check Out
        </button>
      </div>

      {/* Bottom spacer to keep buttons centered, matching EdipiStep's grid feel */}
      <div />
    </div>
  </div>
);

export default MenuStep;
